export default __webpack_public_path__ + "static/media/default-device.840860a6.svg";